export default __webpack_public_path__ + "static/media/strategik1.c78e5750.jpg";